<template>
    <div class="modal fade bd-data-protection-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <!--Content-->
            <div class="modal-content">
                <!--Header-->
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel">Datenschutzerklärung</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <!--Body-->
                <div class="modal-body">
                    
                    <h4>Datenschutz</h4>
                    <br/>
                    <p>
                        Als Betreiber dieser Seiten nehme ich den Schutz Ihrer persönlichen Daten sehr ernst. Ich behandle Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung. 
						<br/><br/>
                        Die Nutzung meiner Website ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf meinen Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben. 
                        <br/><br/>
                        Ich weise darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich. 
                    </p>

                    <br/>
                    <h5>Hinweis zur verantwortlichen Stelle</h5>
                    <p>    Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist: siehe unter Impressum<br/>
                            Telefon: siehe unter Impressum<br/>
                            E-Mail: siehe unter Impressum

                    <br/><br/>
                        Haben Sie Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten oder wünschen Sie eine Auskunft oder die Berichtigung, Löschung oder Sperrung Ihrer Daten, wenden Sie sich bitte an:
                    </p>
                   <p>Sylvia Heimann<br>
                    c/o RIWAS 12<br>
                    Richard-Wagner-Str. 12<br>
                    50674 Köln</p>
                    <p>
                    Email:info(at)heimanns-agentur.de<br>
                    Telefon: 0221 / 846 91-20 <br>
                        Telefax: 0221 / 846 91-19
                    </p>

                    <br/>
                    <h5>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h5>
                    <p>
                       Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an mich. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt. 
                    </p>
                    <br/>
                    <h5>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h5>
                    <p>
                        Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten können folgendem Link entnommen werden: <a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html">Liste der Datenschutzbeauftragten</a>.
                    </p>
                    <br/>
                    <h5>Recht auf Datenübertragbarkeit</h5>
                    <p>Sie haben das Recht, Daten, die ich auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeite, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.
                    </p>
                    <br/>
                    <h5>Recht auf Auskunft, Sperrung, Löschung</h5>
                    <p>Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggfs. ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit unter der im Impressum bzw. der oben angegebenen Adresse an mich wenden.
                    </p>
                    <br/>
                    <h4>Datenerfassung auf dieser Website</h4>
                    <br/>
                    <h5>Cookies</h5>
                    <p>Zur Zeit werden keine Cookies verwendet.</p>
                    <br/>
                    <h5>Server-Log-Files</h5>
                    <p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log Files, die Ihr Browser automatisch an uns übermittelt. Dies sind: </p>
                        <ul>
                        <li>Browsertyp und Browserversion</li>
                            <li>Verwendetes Betriebssystem</li>
                            <li>Referrer URL</li>
                            <li>Hostname des zugreifenden Rechners</li>
                            <li>Uhrzeit der Serveranfrage</li>
                            <li>IP-Adresse</li>
                        </ul>
                     <p>Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Ich behalte mir vor, diese Daten nachträglich zu prüfen, wenn mir konkrete Anhaltspunkte für eine rechtswidrige Nutzung bekannt werden.</p>
                    <br/>

                    <h5>Kontaktformular</h5>
                    <p>Wenn Sie mir per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei mir gespeichert. Diese Daten gebe ich nicht ohne Ihre Einwilligung weiter.</p>
 
                    <p>Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an mich. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.</p>

                    <p>Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei mir, bis Sie mich zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.</p>
                    <p>Zur Zeit ist es noch nicht möglich, die Daten verschlüsselt zu übertragen. Bei Nutzung des Kontaktformular erklären Sie sich ausdrücklich mit der unverschlüsselten Datenübertragung einverstanden.
                        <br/><br/>
                        Ich weise darauf hin, dass die Datenübertragung im Internet Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich. 
                    </p>
                    <br/>



                    <h4>Analysetools</h4>
                    <br/>
                    <p>Ich verwende auf dieser Seite keine Analysetools (wie z.B. Google Analytics, eTracker o.ä.)
                    </p>
                    <br/>
                    <h4>Plugins und Tools</h4>
                    <br/>
                    <h5>Google Web Fonts</h5>
                    <p>Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Web Fonts, die von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web Fonts in ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.
                    </p>
                    <p>Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Google aufnehmen. Hierdurch erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse unsere Website aufgerufen wurde. Die Nutzung von Google Web Fonts erfolgt im Interesse einer einheitlichen und ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.
                    </p>
                    <p>Wenn Ihr Browser Web Fonts nicht unterstützt, wird eine Standardschrift von Ihrem Computer genutzt.
                    </p>
                    <p>Weitere Informationen zu Google Web Fonts finden Sie unter <a href="https://developers.google.com/fonts/faq">https://developers.google.com/fonts/faq</a> und in der Datenschutzerklärung von Google: <a href="https://www.google.com/policies/privacy/">https://www.google.com/policies/privacy/</a>.
                    </p>



                 </div>
            </div>
            <!--/.Content-->
        </div>
    </div>
  
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/DataProtection.vue